export const getField = (state) => state.cropMonitoring.field;
